import { monthNamesEn, monthNamesNo } from './timeStrings';
import { zeroPad } from '../text/padding';
import { LocalDateTime } from './LocalDateTime';
import { LocalTime } from './LocalTime';
import { localized } from '../locale';
var LocalDate = /** @class */ (function () {
    function LocalDate(year, month, day) {
        this.year = year;
        this.month = month;
        this.day = day;
    }
    LocalDate.parse = function (s) {
        var matchDash = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
        var matchPoint = /^(\d{2}).(\d{2}).(\d{4})$/.exec(s);
        if (matchDash) {
            return new LocalDate(parseInt(matchDash[1]), parseInt(matchDash[2]), parseInt(matchDash[3]));
        }
        if (matchPoint) {
            return new LocalDate(parseInt(matchPoint[3]), parseInt(matchPoint[2]), parseInt(matchPoint[1]));
        }
        throw new SyntaxError('Invalid LocalDate: ' + s);
    };
    LocalDate.now = function () {
        var today = new Date();
        return new LocalDate(today.getFullYear(), today.getMonth() + 1, today.getDate());
    };
    LocalDate.prototype.toJSON = function () {
        return "".concat(zeroPad(this.year, 4), "-").concat(zeroPad(this.month, 2), "-").concat(zeroPad(this.day, 2));
    };
    LocalDate.prototype.toString = function () {
        return this.toJSON();
    };
    LocalDate.prototype.withDayOfMonth = function (newDay) {
        return new LocalDate(this.year, this.month, newDay);
    };
    LocalDate.prototype.atStartOfDay = function () {
        return this.atTime(new LocalTime(0, 0, 0));
    };
    LocalDate.prototype.atTime = function (time) {
        return new LocalDateTime(this.year, this.month, this.day, time.hour, time.minute, time.second, time.millisecond);
    };
    LocalDate.prototype.isLeapYear = function () {
        return LocalDate.isLeapYear(this.year);
    };
    LocalDate.prototype.isBefore = function (localDate) {
        return (new Date(this.year, this.month - 1, this.day).getTime() <
            new Date(localDate.year, localDate.month - 1, localDate.day).getTime());
    };
    LocalDate.prototype.isAfter = function (localDate) {
        return (new Date(this.year, this.month - 1, this.day).getTime() >
            new Date(localDate.year, localDate.month - 1, localDate.day).getTime());
    };
    LocalDate.prototype.lengthOfMonth = function () {
        return LocalDate.lengthOfMonth(this.year, this.month);
    };
    LocalDate.prototype.plusYears = function (value) {
        return this.plusMonths(value * 12);
    };
    LocalDate.prototype.minusYears = function (value) {
        return this.minusMonths(value * 12);
    };
    LocalDate.prototype.plusMonths = function (value) {
        return LocalDate.plusMonths(this.year, this.month, this.day, value);
    };
    LocalDate.prototype.minusMonths = function (value) {
        return LocalDate.plusMonths(this.year, this.month, this.day, -value);
    };
    LocalDate.prototype.plusDays = function (value) {
        var day = this.day + value;
        var month = this.month;
        var year = this.year;
        while (day > LocalDate.lengthOfMonth(year, month)) {
            day -= LocalDate.lengthOfMonth(year, month);
            var newDate = LocalDate.plusMonths(year, month, day, 1);
            year = newDate.year;
            month = newDate.month;
        }
        return new LocalDate(year, month, day);
    };
    LocalDate.prototype.toLocaleShortString = function (locale) {
        return localized({
            no: "".concat(zeroPad(this.day, 2), ".").concat(zeroPad(this.month, 2), ".").concat(this.year),
            en: "".concat(zeroPad(this.month, 2), "/").concat(zeroPad(this.day, 2), "/").concat(this.year),
        }, locale);
    };
    LocalDate.prototype.toLocaleString = function (locale) {
        return localized({
            no: "".concat(this.day, ". ").concat(monthNamesNo[this.month], " ").concat(this.year),
            en: "".concat(monthNamesEn[this.month], " ").concat(this.day, ", ").concat(this.year),
        }, locale);
    };
    /* Static helper methods:
     */
    LocalDate.isLeapYear = function (year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    };
    LocalDate.lengthOfMonth = function (year, month) {
        return [31, LocalDate.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1];
    };
    LocalDate.plusMonths = function (year, month, day, nMonths) {
        month += nMonths;
        if (month > 12) {
            year += Math.trunc(month / 12); //div operation: corresponds to integer divisjon
            month = month % 12 === 0 ? 12 : month % 12; //handle december by setting modulus 0 to 12
        }
        if (month < 1) {
            var yearDiff = Math.ceil((1 - month) / 12);
            year -= yearDiff;
            month += 12 * yearDiff;
        }
        day = Math.min(day, LocalDate.lengthOfMonth(year, month)); // handle cases at the end of the month
        return new LocalDate(year, month, day);
    };
    return LocalDate;
}());
export { LocalDate };
